import { SVGProps } from 'react';

const SendScaleMediumAppearanceOutlined = (props: SVGProps<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
            d="M12 13.4996V18.9996M12.2915 19.0842L19.2662 21.4191C19.8142 21.6026 20.0881 21.6943 20.2569 21.6285C20.4034 21.5713 20.5145 21.4486 20.5567 21.2971C20.6054 21.1226 20.4869 20.8592 20.2497 20.3322L12.7296 3.62077C12.4981 3.10644 12.3824 2.84928 12.2216 2.7698C12.082 2.70074 11.9181 2.70074 11.7784 2.7698C11.6177 2.84928 11.5019 3.10645 11.2705 3.62077L3.74776 20.3381C3.51135 20.8634 3.39315 21.1261 3.44164 21.3003C3.48375 21.4517 3.59454 21.5744 3.74078 21.6318C3.90917 21.6978 4.18255 21.6071 4.72931 21.4256L11.7856 19.0836C11.8795 19.0524 11.9264 19.0368 11.9744 19.0307C12.0171 19.0252 12.0602 19.0253 12.1028 19.0308C12.1508 19.0371 12.1977 19.0528 12.2915 19.0842Z"
            stroke="var(--bloko-icon-color, var(--bloko-icon-color-default))"
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);
export default SendScaleMediumAppearanceOutlined;
